/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../Container/Container";
import Grid from "@mui/material/Grid";
import Paper from "../../../node_modules/@mui/material/Paper/Paper";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import jobSectionStyle from "./jobsSectionStyle";
import { Box } from "@mui/material";

const JobsSection = () => {
  return (
    <Box id={"jobs"}>
      <Container sx={jobSectionStyle.container}>
        <Typography variant={"h1"} component={"h3"} sx={jobSectionStyle.headline}>
          Wen wir suchen
        </Typography>
        <Grid container>
          <Grid item xs={12}>
            <Paper component={Grid} container alignItems={"center"} justifyContent={"space-between"} sx={jobSectionStyle.job} elevation={0}>
              <Box>Rechtsanwaltsfachangestellte Teamleitung Vollzeit (m/w/d)</Box>
              <Button sx={jobSectionStyle.button} component={Link} to={"/jobs/rechtsanwaltsfachangestellte-teamleitung"} color={"primary"}>
                mehr erfahren
              </Button>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper component={Grid} container alignItems={"center"} justifyContent={"space-between"} sx={jobSectionStyle.job} elevation={0}>
              <Box>Rechtsanwaltsfachangestellte/r Vollzeit (m/w/d)</Box>
              <Button sx={jobSectionStyle.button} component={Link} to={"/jobs/rechtsanwaltsfachangestellter"} color={"primary"}>
                mehr erfahren
              </Button>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper component={Grid} container alignItems={"center"} justifyContent={"space-between"} sx={jobSectionStyle.job} elevation={0}>
              <Box>Rechtsanwältin/Rechtsanwalt (m/w/d)</Box>
              <Button sx={jobSectionStyle.button} component={Link} to={"/jobs/rechtsanwalt"} color={"primary"}>
                mehr erfahren
              </Button>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper component={Grid} container alignItems={"center"} justifyContent={"space-between"} sx={jobSectionStyle.job} elevation={0}>
              <Box>Rechtsreferendarin / Rechtsreferendar (m/w/d)</Box>
              <Button sx={jobSectionStyle.button} component={Link} to={"/jobs/rechtsreferendar-in"} color={"primary"}>
                mehr erfahren
              </Button>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper component={Grid} container alignItems={"center"} justifyContent={"space-between"} sx={jobSectionStyle.job} elevation={0}>
              <Box>Produktmanager (m/w/d)</Box>
              <Button sx={jobSectionStyle.button} component={Link} to={"/jobs/produktmanager"} color={"primary"}>
                mehr erfahren
              </Button>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper component={Grid} container alignItems={"center"} justifyContent={"space-between"} sx={jobSectionStyle.job} elevation={0}>
              <Box>Senior Developer (m/w/d)</Box>
              <Button sx={jobSectionStyle.button} component={Link} to={"/jobs/developer"} color={"primary"}>
                mehr erfahren
              </Button>
            </Paper>
          </Grid>
        </Grid>
        <br />
      </Container>
    </Box>
  );
};

export default JobsSection;
